import { render, staticRenderFns } from "./importacaoFamilias.vue?vue&type=template&id=73133305&scoped=true&"
import script from "./importacaoFamilias.vue?vue&type=script&lang=js&"
export * from "./importacaoFamilias.vue?vue&type=script&lang=js&"
import style0 from "./importacaoFamilias.vue?vue&type=style&index=0&id=73133305&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73133305",
  null
  
)

export default component.exports